import { WeatherSnowyRainyIcon } from './WeatherSnowyRainyIcon';

/**
 * author: Austin Andrews
 * id 0938BCD1-BCF8-4439-B6B3-A590150878BC
 * name weather-snowy-rainy
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-snowy-rainy.svg
 * tags
 * - Weather 
 */
export const WeatherSleetIcon = WeatherSnowyRainyIcon;
export default WeatherSleetIcon